import moment from 'moment';
import React from 'react';

function percent(count, total) {
	const p = Math.round(count / total * 100);
	return !isNaN(p) && isFinite(p) ? p + '%' : '−';
}

function renderOptions({ value }) {
	return !value ? '-' : (
		<div>
			{value.map((o, i) => (
				<div key={i}>{o.label}</div>
			))}
		</div>
	);
}

function renderTarget(_, { row, priorityTargets }) {
	const target = priorityTargets.find((pt) => pt.value === row.target);
	return target ? target.label : '?';
}

function renderPeriod(_, { row }) {
	return (
		<div>
			<div>{moment(row.starts_at).format('DD.MM.YY')}</div>
			<div>{moment(row.ends_at).format('DD.MM.YY')}</div>
		</div>
	);
}

function renderRemainingDays(_, { row }) {
	const diff = moment(row.ends_at).diff(moment(), 'days');

	return (
		<span>{diff > 0 ? diff : 0}</span>
	);
}

function renderAchievePercent(_, { row }) {
	return (
		<span>{percent(row.current_count, row.target_count)}</span>
	);
}

function renderForecastAchievePercent(_, { row }) {
	const days = moment(row.ends_at).diff(moment(row.starts_at), 'days');
	const diff = moment().diff(moment(row.starts_at), 'days');

	return (
		<span>{percent((row.current_count / (diff > days ? days : diff)) * days, row.target_count)}</span>
	);
}

function renderActions(_, { row, updateById, removeById }) {
	return (
		<div className='action-list'>
			<a
				className='banners-edit-icon'
				onClick={() => updateById(row.id)}
			/>
			<a
				className='remove-icon'
				onClick={() => {
					if (confirm('Delete priority?')) {
						removeById(row.id);
					}
				}}
			/>
		</div>
	);
}

export default [
	[
		{
			index: 'id',
			header: {
				title: 'ID'
			},
			column: {}
		},
		{
			index: 'managers',
			header: {
				title: 'Managers'
			},
			column: {
				render: renderOptions
			}
		},
		{
			index: 'period',
			header: {
				title: 'Period'
			},
			column: {
				render: renderPeriod
			}
		},
		{
			index: 'affiliates',
			header: {
				title: 'Affiliates'
			},
			column: {
				render: renderOptions
			}
		},
		{
			index: 'countries',
			header: {
				title: 'Countries'
			},
			column: {
				render: renderOptions
			}
		},
		{
			index: 'offers',
			header: {
				title: 'Offers'
			},
			column: {
				render: renderOptions
			}
		},
		{
			index: 'target_count',
			header: {
				title: 'Target count'
			},
			column: {}
		},
		{
			index: 'target',
			header: {
				title: 'Target'
			},
			column: {
				render: renderTarget
			}
		},
		{
			index: 'current_count',
			header: {
				title: 'Current count'
			},
			column: {}
		},
		{
			index: 'achieve_percent',
			header: {
				title: 'Achieve %'
			},
			column: {
				render: renderAchievePercent
			}
		},
		{
			index: 'forecast_achieve_percent',
			header: {
				title: 'Forecast achieve %'
			},
			column: {
				render: renderForecastAchievePercent
			}
		},
		{
			index: 'remaining_days',
			header: {
				title: 'Remaining days'
			},
			column: {
				render: renderRemainingDays
			}
		},
		{
			index: 'status',
			header: {
				title: 'Status'
			},
			column: {}
		},
		{
			index: 'actions',
			header: {
				title: 'Actions'
			},
			column: {
				render: renderActions
			}
		}
	]
];



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/priorities/table-initial-data.js